import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject} from "rxjs";
import { environment } from "src/environments/environment";
import { ListaContactos } from "../interfaces/ListaContactosData"; 

@Injectable({
    providedIn: 'root'
  })

export class ListaContactosService{
      private baseApi = environment.baseApi + '/contacts';

      private tokenSubject = new Subject<string>();

      constructor(private http: HttpClient){}

      setToken(token: string): void {
        this.tokenSubject.next(token);
      }
    
      getToken(): Observable<string> {
        return this.tokenSubject.asObservable();
      }

      getListaById(id: string): Observable<ListaContactos> {
        return this.http.get<ListaContactos>(`${this.baseApi}/${id}`);
      }
      

      getAllContactos(token: string): Observable<ListaContactos[]> {
        return this.http.get<ListaContactos[]>(`${this.baseApi}/byToken/${token}`);
      }

      createLista(lista: ListaContactos, archivo: File | null): Observable<ListaContactos> {
        const formData = new FormData();
        const blob = new Blob([JSON.stringify(lista)], { type: "application/json" });
        formData.append('lista', blob); 

        if (archivo) {
          formData.append('archivo', archivo); // Si hay un archivo, agregarlo al FormData
        }
        console.log(formData);
        return this.http.post<ListaContactos>(`${this.baseApi}/create`, formData);
      }

      updateLista(id: string, lista: ListaContactos, archivo: File | null): Observable<any> {
        const formData = new FormData();
        const blob = new Blob([JSON.stringify(lista)], { type: "application/json" });
        formData.append('lista', blob); 
      
        if (archivo) {
          formData.append('archivo', archivo); 
        }
        return this.http.put(`${this.baseApi}/update/${id}`, formData);
      }
      


      eliminarLista(id: string): Observable<void> {
        return this.http.delete<void>(`${this.baseApi}/delete/${id}`)
      }
} 